"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
/**
 * Animation easing equations - linear
 *
 * @param pos - a number from 0.0-1.0 representing the fraction of completion
 */
function easingLinear(pos) {
    return pos;
}
exports.easingLinear = easingLinear;
//# sourceMappingURL=linear.js.map